function initHero(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const slides = [...root.querySelectorAll('[data-hero-slide]')];
  if (slides.length < 2) return;
  const controls = root.querySelector('[data-hero-controls]');
  const pause = root.querySelector('[data-hero-pause]');
  const position = root.querySelector('[data-hero-position]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let current = 0, timer, paused = root.dataset.autoplay !== 'true' || reduced.matches, hover = false;
  const duration = Math.max(3, Math.min(15, Number(root.dataset.duration) || 5)) * 1000;
  function schedule() {
    clearTimeout(timer);
    if (!root.isConnected || paused || hover || document.hidden || root.contains(document.activeElement)) return;
    timer = setTimeout(() => show(current + 1), duration);
  }
  function show(index) {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== current; });
    position.textContent = `${current + 1} / ${slides.length}`;
    schedule();
  }
  function label() { pause.textContent = paused ? root.dataset.i18nPlay : root.dataset.i18nPause; pause.setAttribute('aria-label', paused ? root.dataset.i18nResume : root.dataset.i18nPauseLabel); pause.setAttribute('aria-pressed', String(paused)); }
  controls.hidden = false; label(); show(0);
  root.querySelector('[data-hero-prev]').addEventListener('click', () => show(current - 1));
  root.querySelector('[data-hero-next]').addEventListener('click', () => show(current + 1));
  pause.addEventListener('click', () => { paused = !paused; label(); schedule(); });
  root.addEventListener('mouseenter', () => { hover = true; schedule(); });
  root.addEventListener('mouseleave', () => { hover = false; schedule(); });
  root.addEventListener('focusin', schedule);
  root.addEventListener('focusout', () => setTimeout(schedule, 0));
  document.addEventListener('visibilitychange', schedule);
  reduced.addEventListener('change', () => { if (reduced.matches) paused = true; label(); schedule(); });
  document.addEventListener('shopify:block:select', event => { const i = slides.findIndex(s => s === event.target || s.contains(event.target)); if (i >= 0) { paused = true; label(); show(i); } });
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) clearTimeout(timer); });
}
document.querySelectorAll('[data-ykt-hero]').forEach(initHero);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ykt-hero]').forEach(initHero));
